import { useEffect } from "react";

/**
 * Fires `handler` when a pointer event happens outside `ref.current`.
 * Pass `active=false` to skip attaching listeners when not needed
 * (e.g. while a dropdown is closed) to avoid unnecessary work.
 */
export default function useClickOutside(ref, handler, active = true) {
    useEffect(() => {
        if (!active) return undefined;

        function handlePointerDown(event) {
            const el = ref.current;
            if (!el || el.contains(event.target)) return;
            handler(event);
        }

        document.addEventListener("mousedown", handlePointerDown);
        document.addEventListener("touchstart", handlePointerDown);
        return () => {
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("touchstart", handlePointerDown);
        };
    }, [ref, handler, active]);
}